import { SupabaseTableBase } from '../../utils/SupabaseTableBase';
import { CallWhatToSaySuggestion } from './types';

export class CallWhatToSaySuggestionService extends SupabaseTableBase<CallWhatToSaySuggestion> {
  constructor() {
    super('callWhatToSaySuggestion');
  }

  async createWhatToSaySuggestion(callId: string, trigger: string, suggestion: string, datetime: string): Promise<CallWhatToSaySuggestion | null> {
    const whatToSaySuggestionData = {
      callId,
      trigger,
      suggestion,
      datetime
    };

    const result = await this.insertRecord(whatToSaySuggestionData);
    return result.data;
  }

  async getWhatToSaySuggestionsByCallId(callId: string): Promise<CallWhatToSaySuggestion[]> {
    const result = await this.selectRecordsByColumn('callId', callId, {
      orderBy: 'datetime',
      ascending: true
    });

    return result.data || [];
  }
}
